import L from "leaflet";
import { useEffect, useState } from "react";
import { useAppConfigContext } from "../../providers/hooks/AppConfigContext";
import { useFiltersData } from "../../providers/hooks/FiltersContext";
import { useMap } from "../../providers/hooks/MapContext";
import ProductsAPI from "../../services/ProductsAPI";

export default function DataByAreaControl() {
  const appConfig = useAppConfigContext();
  const filters = useFiltersData();
  const map = useMap();
  const [pmControl, setPMControl] = useState(null);

  // Set area calculation control
  useEffect(() => {
    if (map) {
      if (!pmControl) {
        map.pm.addControls({
          position: "topleft",
          drawCircle: false,
          drawMarker: false,
          drawPolyline: false,
          cutPolygon: false,
          drawCircleMarker: false,
          drawRectangle: false,
          editMode: false,
          dragMode: false,
        });

        map.pm.setLang("pt_br");

        setPMControl(true);
      }

      if (filters?.payload()) {
        map.removeEventListener("pm:create");

        map.on("pm:create", (e) => {
          const fg = L.featureGroup();
          map.eachLayer((l) => {
            if (l instanceof L.Polygon && l.pm) {
              fg.addLayer(l);
            }
          });

          const geojson = fg.toGeoJSON().features;

          const request = {
            geojson: geojson[geojson.length - 1].geometry,
            filters: filters.payload(),
          };

          return ProductsAPI.fetchDataByArea(request).then((resp) => {
            if ((resp?.count || 0) > 0) {
              let tablePresentation = appConfig.tablePresentation(resp);

              tablePresentation +=
                '<button title="Imprimir cálculo" class="print-measures" onclick="window.printDataCalc()">🖨 Imprimir</button>';

              e.layer.bindPopup(tablePresentation).openPopup();
            } else {
              e.layer
                .bindPopup("Nenhuma unidade produtiva nesta área")
                .openPopup();
            }
          });
        });
      }
    }
  }, [appConfig, filters, map, pmControl]);

  return <></>;
}
